<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Prévoyance Indemnités Journalières lors d'Hospitalisation (IJH)</h2>
  </div>
  
  <div class="content-section">
    <h2 class="purple-title">ELEMENTS DE CONTEXTE :</h2>
    <p>
      Au sujet de l'utilité de l'assurance Prévoyance IJH, il faut savoir qu'en 2019, près de 14 millions de patients ont été hospitalisés en France. Vous savez ce que cela représente en matière de statistique, c'est-à-dire la malchance pour que cela tombe sur nous ? <strong class="highlight-purple">Cela représente 1 français sur 5, soit 1 famille sur 3.</strong> C'est absolument énorme.
    </p>
    <p>
      Par ailleurs, nous avons aussi d'autres statistiques (issues de 3300 établissements en France) :
    </p>
    <ul>
      <li>La durée moyenne de séjour en Médecine, Chirurgie, Obstétriques, et odontologiques (endoscopie, pathologie cardio-vasculaire, cancer, prothèse totale de hanche, AVC) est de <strong class="highlight-purple">6 jours</strong>,</li>
      <li>Elle est de <strong class="highlight-purple">35 jours</strong> en soins de suite et de réadaptation.</li>
    </ul>
    <p>
      Par ailleurs, il faut savoir que les tarifs d'hospitalisation par jour vont de <strong class="highlight-purple">500€</strong> (en médecine) à <strong class="highlight-purple">3800€</strong> (Réanimation) en passant par <strong class="highlight-purple">1600€</strong> pour chirurgie.
    </p>
    <p>
      Il faudra bien distinguer la prise en charge financière des coûts de l'hospitalisation en reste à charge comme les dépassements d'honoraires, ou la chambre particulière par l'assurance Prévoyance IJH via le versement d'une indemnité journalière de la prise en charge des soins de santé par l'Assurance Mutuelle Individuelle accessible sur <a routerLink="/cac/particuliers/assurance-sante-particuliers" class="link-purple">cette page</a>.
    </p>
    <p>
      Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, POP SANTE, FMA, ASAF & AFPS, HENNER, APIVIA MACIF, AVENIR MUTUELLE, IDENTITE MUTUELLE, UCR, PRAECONIS…</strong>
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">QU'EST-CE QUE LE CONTRAT D'IJH ?</h2>
    <p>
      Un contrat d'assurance Indemnités Journalières en cas d'Hospitalisation, ou IJH, permet le versement d'une allocation journalière en cas d'hospitalisation médicale (hospitalisé pour une maladie), maternité ou chirurgicale (hospitalisé pour une opération). Le versement de cette allocation peut durer <strong class="highlight-purple">1095 jours soit 3 ans MAX</strong>, à compter du 1er jour.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">À QUOI CA SERT ?</h2>
    <p>
      Il faut savoir qu'une hospitalisation dure souvent plus d'une journée.
    </p>
    <p>
      Une hospitalisation engendre toujours des frais non remboursés par la SS et non remboursés par les complémentaires santé (les mutuelles). Ces frais à la charge du patient vont de <strong class="highlight-purple">15€ par jour à 45€ par jour</strong> en dehors des frais de confort.
    </p>
    <p>
      Lors d'une hospitalisation, il arrive souvent que le praticien fasse des dépassements d'honoraires, et que la mutuelle ne prenne pas souvent intégralement en charge.
    </p>
    <p>
      Par ailleurs, on oublie souvent que l'hospitalisation provoque souvent des frais indirects comme :
    </p>
    <ul>
      <li>Vous n'avez pas le droit au Mobile et devez donc appeler depuis la ligne fixe de l'hôpital qui surfacture les appels,</li>
      <li>Les proches doivent souvent se déplacer vous voir, et donc des billets de transports sont à payer,</li>
      <li>Si vous vous occupez de votre conjoint dépendant, des enfants, ou petits-enfants, de vos animaux domestiques, de vos plantes, du ménage, etc., il faudrait prévoir une aide, et cette aide à votre charge,</li>
      <li>Les frais d'installation d'un accompagnant sont à votre charge,</li>
      <li>Les repas de l'accompagnateur sont à votre charge.</li>
    </ul>
    <p>
      Enfin, lorsque vous êtes à l'hôpital, vous voulez avoir le même confort qu'à la maison :
    </p>
    <ul>
      <li>Vous voulez avoir une télévision. Celle-ci est payante à l'hôpital,</li>
      <li>La presse est souvent plus chère à l'hôpital,</li>
      <li>Vous souhaitez être seule dans votre chambre. La mutuelle santé limite la prise en charge de la chambre particulière. Cela peut tout de suite vous revenir très cher,</li>
    </ul>
    <p>
      Avec un contrat IJH, vous couvrez l'ensemble des frais liés à une éventuelle hospitalisation, ainsi cela vous permet :
    </p>
    <ul>
      <li>De vous offrir du confort et du bien-être au malade,</li>
      <li>De gagner en tranquillité d'esprit,</li>
      <li>Vous dégagez des soucis financiers et vous préoccupez uniquement de votre rétablissement rapide.</li>
    </ul>
    <p>
      En d'autres termes, la garantie IJH vous apporte un confort supplémentaire à partir de quelques euros par mois.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">GAINS VERSUS COTISATION :</h2>
    <p>
      Avec un contrat IJH, vous pouvez éventuellement recevoir la somme de <strong class="highlight-purple">30j * 100€ = 3000€ par mois</strong> pour mois de <strong class="highlight-purple">900€ par an</strong> pour des profils de votre âge.
    </p>
    <p>
      Et cela peut aller, en cas d'accident, et une hospitalisation de 3 ans, jusqu'à la somme de <strong class="highlight-purple">1095j * 100€ = 1 00 950€</strong> pour moins de <strong class="highlight-purple">900€ par an</strong>.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">POINTS FORTS :</h2>
    <p>
      Ce contrat d'assurance est quelque chose qu'il faut absolument souscrire et surtout à votre âge où les risques d'hospitalisation sont plus élevés. En effet, voici les points forts du contrat :
    </p>
    <ul>
      <li>Votre cotisation mensuelle est définie en fonction de votre âge actuel, et n'augmente que par tranche d'âge dépassée. <em>Exemple : Vous souscrivez à 50 ans un contrat qui vous coûte 20€ par mois, vous payez cette cotisation pendant 9 ans. A 60 ans le tarif va augmenter de 10% seulement</em>,</li>
      <li>Vos indemnités sont exonérées d'impôts – Vous touchez 36 000€ pour 1 an d'hospitalisation, pas d'impôt sur cette somme,</li>
      <li>Vous n'avez pas besoin de justifier vos dépenses, vous faites ce que vous voulez avec cet argent,</li>
      <li>Ce contrat ne demande aucune formalité médicale,</li>
      <li>Le contrat est ultra simple et rapide à mettre en place (5 minutes max) et vous êtes couvert,</li>
      <li>En cours de contrat, aucun bénéficiaire des prestations ne peut être exclu de la garantie ni voir sa cotisation majorée en raison d'une dégradation de son état de santé,</li>
      <li>Prise en charge à compter du 1er jour jusqu'à 365 jours pour une maladie et 3 ans pour un accident,</li>
      <li>Chez certains assureurs, l'hospitalisation à domicile est également garantie,</li>
      <li>Le contrat fonctionne également à l'étranger (si séjour de moins de 2 mois et limité à 30 jours par une règle générale).</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">EXCLUSIONS :</h2>
    <p>
      Dans tout contrat d'assurance, il y a des EXCLUSIONS. Alors quelles sont ces exclusions ? Comme vous pouvez vous en douter, les conditions suivantes ne donnent pas droit à indemnités :
    </p>
    <ul>
      <li>Les séjours en établissements ou unités spécialisées : psychiatrique, soins de suite, réadaptation,</li>
      <li>Les séjours qui sont en cours à la date d'adhésion dans tous types d'établissements,</li>
      <li>Les séjours du fait volontaire du bénéficiaire, y compris la mutilation volontaire et la tentative de suicide,</li>
      <li>Les séjours du fait de l'usage de stupéfiants non ordonnés médicalement,</li>
      <li>Les séjours des suites et conséquences des affections, maladies s'étant exposées pendant le délai d'attente,</li>
      <li>Les séjours pour accouchement sans intervention chirurgicale,</li>
      <li>Les séjours du fait de maladie, accident ou de leurs séquelles, ou invalidité survenus antérieurement à la date de souscription,</li>
      <li>Les séjours du fait de chirurgie esthétique et les actes esthétiques non consécutifs à un accident ; le caractère esthétique est établi par le Médecin Conseil de l'organisme assureur,</li>
      <li>Les séjours de cures de sommeil, amaigrissement, rajeunissement, désintoxication, ainsi que leurs suites,</li>
      <li>Les séjours en établissements médico-sociaux : établissements pour personnes handicapées (instituts ou centres médico-psychopédagogiques, instituts médico-éducatifs, maisons accueil spécialisés, institut médicoprofessionnel, foyer d'accueil médicalisé, service d'accueil médico-social pour adulte handicapé…) , établissements pour personnes âgées (maison de retraite, établissement hébergeant des personnes âgées dépendantes, service de soins infirmiers à domicile…), les CCAA, ACT, CAARUD, LHSS… .</li>
      <li>Chez certains assureurs, l'hospitalisation à domicile est exclue.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">VIGILENCE SUR LE PRODUIT :</h2>
    <p>
      Il n'est pas possible de souscrire ce contrat à partir d'un certain âge, car les risques d'hospitalisation sont très élevés.
    </p>
    <p>
      De la même façon, il faut savoir que passé un certain âge, votre contrat s'arrête automatiquement. Cet âge va de <strong class="highlight-purple">75 ans à 83 ans</strong> en fonction de l'assureur.
    </p>
    <p>
      Il ne faut surtout pas perdre de vue que comme tout contrat d'assurance il peut exister des franchises et des délais de carence/attente. Ces franchisent et délais varient en fonction des assureurs.
    </p>
    <p>
      Dans tous les cas, les franchises sont les suivantes :
    </p>
    <ul>
      <li>En cas d'hospitalisation pour cause de maladie garantie, si vous faites mois de <strong class="highlight-purple">48h ou 72h</strong> alors vous ne bénéficierez pas de votre indemnité. Si vous dépassez les 48h ou 72h, vous serez indemnisé dès le 1er jour,</li>
      <li>En cas d'hospitalisation pour cause d'accident garanti, si vous faites des mois de <strong class="highlight-purple">24h</strong> alors vous ne bénéficierez pas de votre indemnité. Si vous dépassez les 24h, vous serez indemnisé dès le 1er jour.</li>
    </ul>
    <p>
      Dans tous les cas, les délais de carences/attentes sont les suivants :<br>
      <em>Exemple en franchise :</em>
    </p>
    <ul>
      <li>En cas d'hospitalisation pour cause de maternité, si votre contrat n'a pas été signé il y plus de <strong class="highlight-purple">9, 10 ou 12 mois</strong>, alors vous ne bénéficierez pas de votre indemnité.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">OPTIONS POSSIBLES :</h2>
    <p>
      Certains contrats constituent une garantie "Capital Décès" située entre <strong class="highlight-purple">3000€ et 4000€</strong> qui est versée au bénéficiaire désigné au contrat en cas d'accident de type :
    </p>
    <ul>
      <li>Les accidents de transports en commun,</li>
      <li>Les accidents de la circulation,</li>
      <li>Les accidents de trajet professionnel,</li>
      <li>Les accidents de sports.</li>
    </ul>
    <p>
      Dans certains cas, vous bénéficiez également de prestations d'Assistance (différents services d'aides pris en charge par l'assisteur).
    </p>
    <p>
      Bien évidemment, ces options ont un coût.
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">QUE FAIRE EN CAS D'HOSPITALISATION ?</h2>
    <p>
      En cas d'hospitalisation, vous devez envoyer très rapidement certaines pièces justificatives de votre séjour. Il s'agit notamment de :
    </p>
    <ul>
      <li>La copie du Certificat d'Adhésion au contrat,</li>
      <li>Le compte-rendu d'hospitalisation remis par l'établissement dans lequel vous avez séjourné,</li>
      <li>Le bulletin d'hospitalisation ou de situation : Document que vous remet le service des admissions. Vous pouvez en demander une toutes les semaines.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">QUAND EST-CE QUE JE SERAI PAYE ?</h2>
    <p>
      Le règlement interviendra au plus tard dans les <strong class="highlight-purple">15 jours</strong> qui suivront la date de l'accord de garantie. Ce qui veut dire que vous devez récupérer très rapidement toutes les pièces qui prouvent votre séjour. Pour toute hospitalisation supérieure à 30 jours, possibilité de versement d'acomptes.
    </p>
  </div>
</app-page-layout>

